import { ClusteredMarkerLayer } from '../Layers/ClusteredMarkersLayer';
import { FilterLayer } from '../Layers/FilterLayer';
import type { FilterLayerOptions } from '../Layers/Layers.types';

export const roadFilterPlannedRoadwork = function (layers: ClusteredMarkerLayer[], options?: FilterLayerOptions): FilterLayer {
    const defaultOptions: FilterLayerOptions = {
        filterFn: (filteredFeatures, allFeatures) => {
            return allFeatures.filter((feature) => {
                const props = feature.properties;
                return filteredFeatures.includes(feature) || (props.isFuture && props.messageType && props.messageType === 'Vägarbete');
            });
        },
    };

    return new FilterLayer('road-filter-planned-roadwork', layers, { ...defaultOptions, ...options });
};
